module.exports = __webpack_public_path__ + "assets/lineto-circular-pro-black.ff9a61289e6afc0ebb42fe99d2520773.woff";